import { CityBean, CountryBean, DeviceTypeBean, DictionariesControllerApi, IabCategoryBean, LanguageBean, RegionBean, TimeZoneBean } from '../api/api'
import { BaseApi, configuration } from '../api/BaseApi'

class DictionariesApi extends BaseApi {
    api: DictionariesControllerApi

    constructor() {
        super()
        this.api = new DictionariesControllerApi(configuration, configuration.basePath, this.fetch)
    }

    languages(): Promise<Array<LanguageBean>> {
        return this.call(() => this.api.language())
    }

    iabCategories(): Promise<Array<IabCategoryBean>> {
        return this.call(() => this.api.iabCategories())
    }

    countries(): Promise<Array<CountryBean>> {
        return this.call(() => this.api.countries())
    }

    regions(country: string): Promise<Array<RegionBean>> {
        return this.call(() => this.api.regions(country))
    }

    cities(region: string): Promise<Array<CityBean>> {
        return this.call(() => this.api.cities(region))
    }

    citiesByCountry(region: string): Promise<Array<CityBean>> {
        return this.call(() => this.api.citiesByCountry(region))
    }

    platforms(): Promise<Array<String>> {
        return this.call(() => this.api.platforms())
    }

    timezones(): Promise<Array<TimeZoneBean>> {
        return this.call(() => this.api.timezone())
    }

    deviceTypes(): Promise<Array<DeviceTypeBean>> {
        return this.call(() => this.api.deviceTypes())
    }
}

const dictionariesApi = new DictionariesApi()
export default dictionariesApi


// WEBPACK FOOTER //
// ./src/util/DictionariesApi.ts